/**
 * ZenMarkup Privacy Analytics — User Journeys renderer.
 *
 * Shows the most common page sequences (paths) visitors take.
 * Extracted from insights.js to keep modules under 200 lines.
 */

import { formatDuration } from './charts.js';
import { setWidgetContent } from './table-builder.js';

/**
 * Render User Journeys table.
 *
 * Shows the most common page sequences (paths) visitors take.
 *
 * @param {Object} data  Full stats response data.
 */
export function render(data) {
	const section = document.getElementById('zmpa-user-journeys-section');
	const card = document.querySelector('[data-el="user-journeys"]');
	if (!card) {
		return;
	}

	const paths = data.top_paths || [];
	if (!paths.length) {
		if (section) { section.style.display = 'none'; }
		return;
	}

	if (section) { section.style.display = ''; }

	const content = document.querySelector('[data-el="content"]');
	const arrowSvg = content ? content.getAttribute('data-icon-arrow-right') : '';
	const chevronRightSvg = content ? content.getAttribute('data-icon-chevron-right') : '';
	const chevronDownSvg = content ? content.getAttribute('data-icon-chevron-down') : '';

	const wrap = document.createElement('div');
	wrap.className = 'zmpa-list';

	const header = document.createElement('div');
	header.className = 'zmpa-list-header';
	const durLabel = window.innerWidth < 600 ? 'Avg. Dur.' : 'Avg. Duration';
	header.innerHTML = '<span>Path</span><span>Sessions</span><span>' + durLabel + '</span>';
	wrap.appendChild(header);

	paths.forEach(function (p) {
		const row = document.createElement('div');
		row.className = 'zmpa-list-row';

		const nameEl = document.createElement('span');
		nameEl.className = 'zmpa-list-name zmpa-journey-path';

		const COLLAPSE_THRESHOLD = 5;
		var pathParts = p.path.split(/\s*→\s*/);
		var needsCollapse = pathParts.length > COLLAPSE_THRESHOLD;

		function appendStep(part, container) {
			const seg = document.createElement('span');
			seg.className = 'zmpa-journey-step';
			seg.textContent = part;
			container.appendChild(seg);
		}

		function appendArrow(container) {
			const arrow = document.createElement('span');
			arrow.className = 'zmpa-journey-arrow';
			arrow.innerHTML = arrowSvg;
			container.appendChild(arrow);
		}

		if (needsCollapse) {
			var hiddenCount = pathParts.length - 3;

			/* Preview: first 2 → … → last */
			const preview = document.createElement('span');
			preview.className = 'zmpa-journey-preview';
			appendStep(pathParts[0], preview);
			appendArrow(preview);
			appendStep(pathParts[1], preview);
			appendArrow(preview);
			const dots = document.createElement('span');
			dots.className = 'zmpa-journey-dots';
			dots.textContent = '…';
			preview.appendChild(dots);
			appendArrow(preview);
			appendStep(pathParts[pathParts.length - 1], preview);
			nameEl.appendChild(preview);

			/* Full path (hidden by default) */
			const full = document.createElement('span');
			full.className = 'zmpa-journey-full';
			pathParts.forEach(function (part, i) {
				if (i > 0) { appendArrow(full); }
				appendStep(part, full);
			});
			nameEl.appendChild(full);

			/* Toggle button — chevron accordion */
			const toggle = document.createElement('button');
			toggle.className = 'zmpa-journey-toggle';
			toggle.type = 'button';
			toggle.innerHTML = chevronRightSvg + '<span>' + hiddenCount + ' more</span>';
			toggle.title = 'Show all ' + pathParts.length + ' steps';
			nameEl.appendChild(toggle);

			toggle.addEventListener('click', function (e) {
				e.stopPropagation();
				const isExpanded = nameEl.classList.toggle('zmpa-journey-expanded');
				toggle.innerHTML = isExpanded
					? chevronDownSvg + '<span>collapse</span>'
					: chevronRightSvg + '<span>' + hiddenCount + ' more</span>';
			});
		} else {
			pathParts.forEach(function (part, i) {
				if (i > 0) { appendArrow(nameEl); }
				appendStep(part, nameEl);
			});
		}

		const sessions = document.createElement('span');
		sessions.className = 'zmpa-list-count';
		sessions.textContent = Number(p.sessions).toLocaleString();

		const dur = document.createElement('span');
		dur.className = 'zmpa-list-count';
		dur.textContent = formatDuration(p.avg_duration);

		row.appendChild(nameEl);
		row.appendChild(sessions);
		row.appendChild(dur);
		wrap.appendChild(row);
	});

	setWidgetContent('user-journeys', wrap);
}
